import { ScrollArea, ScrollBar } from "../components/ScrollArea";
import { cn } from "../lib";
import React from "react";
const IconSwatch = ({ icon: IconComponent, onClick, isSelected, }) => (React.createElement("button", { onClick: onClick, className: cn("flex h-8 w-8 items-center justify-center rounded-lg border border-border transition duration-300", isSelected
        ? "bg-highlight-50"
        : "bg-muted-background hover:border-highlight-100 hover:bg-highlight-50") },
    React.createElement(IconComponent, { className: "h-5 w-5 text-foreground" })));
const ColorSwatch = ({ color, onClick, isSelected }) => {
    return (React.createElement("div", { className: cn(`${color} h-5 w-5 cursor-pointer rounded transition duration-200 hover:scale-110`, isSelected && "scale-110"), onClick: () => onClick(color) }));
};
/**
 * A scrollable grid of named icon swatches for choosing an icon, e.g. when
 * customising an entity (agent avatar, folder, label). It renders the grid
 * only; mount it inside a PopoverRoot / PopoverContent triggered by a Button.
 * @summary Grid picker for icons.
 */
export const IconPicker = ({ icons, onIconSelect, selectedIcon, }) => {
    return (React.createElement(ScrollArea, { className: "h-[340px] w-fit overflow-auto" },
        React.createElement("div", { className: "w-auto grid h-fit w-fit grid-cols-8 gap-1.5 p-4" }, Object.entries(icons).map(([name, IconComponent]) => (React.createElement(IconSwatch, { key: name, icon: IconComponent, onClick: () => onIconSelect(name), isSelected: selectedIcon === name })))),
        React.createElement(ScrollBar, { orientation: "vertical", size: "compact" })));
};
/**
 * A grid of color swatches for choosing an accent colour, e.g. when
 * customising an entity (agent avatar, folder, label). It renders the grid
 * only; mount it inside a PopoverRoot / PopoverContent triggered by a Button.
 * @summary Grid picker for colors.
 */
export const ColorPicker = ({ colors, onColorSelect, selectedColor, }) => {
    return (React.createElement("div", { className: "w-auto grid h-fit w-fit grid-cols-8 gap-1.5" }, colors.map((color) => (React.createElement(ColorSwatch, { key: color, color: color, onClick: () => onColorSelect(color), isSelected: selectedColor === color })))));
};
//# sourceMappingURL=Picker.js.map